import React from 'react';
import { Input as AntInput } from 'antd';
import classNames from 'classnames';

/**
 * OTP (One-Time Password) input component wrapper around Ant Design's OTP input. Defaults to jumbo size
 * 
 * {@link https://ant.design/components/input#api}
 *
 * @param {Object} props - The component props
 * @param {boolean} [props.disabled] - Whether the OTP input is disabled
 * @param {string} [props.className] - Additional CSS class name
 * @param {string} [props.size] - Size of the OTP input - jumbo, large, middle, small
 * @param {...*} restProps - Additional props passed to the underlying Ant Design OTP component
 * @returns {React.ReactElement} The rendered OTP input component
 */
const OTP = ( { disabled, size, className, ...restProps } ) => {
    const otpClasses = classNames( {
        [ 'ant-otp' ]: true,
        [ 'ant-otp-input' ]: true,
        [ `otp-${ size }` ]: size ? true : false,
        [ className ]: className ? true : false
    } );
    console.log( otpClasses );
    return (
        <AntInput.OTP
            size={ size }
            { ...restProps }
            prefixCls={ otpClasses }
            disabled={ disabled }
        />
    );
};

export default OTP;
